import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { StreamAction } from '../stream.action';

export const removeStreamDoneEpic: IEpic = (action$) => action$.pipe(
  isTypeOfAndGetPayload(StreamAction.remove.done),
  mergeMap(() => {
    return [
      StreamAction.processing.done({}),
    ];
  }),
);
